"use strict";

import utils from './_utils';
import {MVEditor} from "./_multi-value-editor";

function ieEditMulti($editorEl) {

    if($editorEl.data('toggle') === 'popover'){
        $editorEl.popover('dispose');
    }

    utils.clearSelection();

    let $editorPart = $editorEl.find('.inline-editor');
    let $originalPart = $editorEl.find('.inline-original');

    const editor = {
        multi: false,
        entryId: $editorEl.data('id'),
        entryField: $editorEl.data('inlineEditable'),
        mode(mode){
            $originalPart.toggleClass('d-none', (mode === 'editor'));
            $editorPart.toggleClass('d-none', (mode === 'preview'));

            if(mode === 'preview'){
                $editorPart.off('click');
                $editorPart.off('keypress');
                $editorPart.off('keydown');
            } else {
                MVEditor.initPhoneTypeSelectrs($editorPart);
            }
        },
        cancel(){
            editor.mode('preview');
            editor.updateEditorHTML();
        },
        save() {
            $originalPart.find('.preview').html('<span class="oc-loading"></span>');
            editor.mode('preview');

            let values = [];

            let $valuesEl = $editorPart.find('input, textarea');
            if($valuesEl.length === 1){
                values = $valuesEl.val();
            } else {
                $valuesEl.each(function (num, el) {
                    values.push( $(el).val() );
                });
            }

            if (editor.entryField === 'phones'){
                values = [];
                $valuesEl = $editorPart.find('.input-group.with-phone-select-init');
                $valuesEl.each(function (num, el) {
                    values.push( {
                        type: $(el).find('select.phone-type-select').val(),
                        number: $(el).find('input').val(),
                    } );
                });
            }

            let fieldUpdateData = {
                id: editor.entryId,
                field: editor.entryField,
                value: values
            };

            $.request('onEdit', {
                flash: true,
                success: function(){

                    $.post('/api/v1/editable/original', {
                        id: editor.entryId,
                        field: editor.entryField,
                        multi: editor.multi
                    }, function (response) {
                        $originalPart.find('.preview').html(response);

                        editor.updateEditorHTML();
                    });

                },
                handleErrorMessage: function(message) {
                    $.oc.flashMsg({ text: message, class: 'error' })
                },
                handleFlashMessage: function(message, type) {
                    $.oc.flashMsg({ text: message, class: type })
                },
                data: fieldUpdateData
            });
        },
        updateEditorHTML(){
            $.post('/api/v1/editable/editor', {
                id: editor.entryId,
                field: editor.entryField,
                multi: editor.multi
            }, function (response) {
                $editorPart.html(response);
            });
        },
        bindEditorEvents(){

            $editorPart
                .on('click', 'button[data-remove-field]', function () {
                    $(this).closest('.input-group').remove()
                })
                .on('click', 'button[data-close-editor]', function () {
                    editor.cancel();
                })
                .on('click', 'button[data-inline-add-row]', function () {
                    let template = $editorPart.find('.inputTemplate').html();
                    $editorPart.append(template);

                    MVEditor.initPhoneTypeSelectrs($editorPart);
                })
                .on('click', 'button[data-inline-save]', function () {
                    editor.save();
                })
                .on('keypress', 'input', this.keypressEventHandler)
                .on('keydown', 'input', this.keypressEventHandler)
            ;
        },
        keypressEventHandler: function(e){
            if(e.type === 'keydown'){
                if(e.key === 'Escape' || e.keyCode === 27){
                    editor.cancel();
                }
            }
            if(e.type === 'keypress'){
                if((e.key === 'Enter' || e.keyCode === 13) && e.shiftKey === false){
                    editor.save();
                }
            }
        },
    };

    if($editorEl.hasClass('multiline')){
        editor.multi = true;
    }

    editor.bindEditorEvents();

    editor.mode('editor');

    let el = $editorEl.find('input')[0];
    if(el){
        el.focus();
    }

}

const inlineEditor = {
    init: function () {
        $('[data-inline-editable].multiline:not(.ie-init)')
            .on('dblclick', function () {
                $(this).find('button[data-enable-editor]').trigger('click')
            })
            .addClass('ie-init');
        $('button[data-enable-editor]:not(.ie-init)')
            .on('click', function () {
                if(! $(this).closest('.inline-original').hasClass('d-none')){
                    ieEditMulti($(this).closest('div[data-inline-editable]'));
                }
            })
            .addClass('ie-init');
        $('[data-inline-editable]:not(.multiline):not(.ie-init)')
            .on('dblclick', function () {
                ieEditMulti($(this));
            })
            .addClass('ie-init');
    },
};


(function () {

    // Auto run

})();


export { ieEditMulti, inlineEditor };
